import { HistoryController, ViewType } from "@ortho-next/nextray-core";
import { Main } from "../../Core/Main";
import { bindedModel } from "../../Models/BindedModel";
import { EoCPlane } from "./EoCPlane";
import { EoCPlaneMechanical } from "./EoCPlaneMechanical";

export class EoCPlaneManager {
	public synced = false;
	public EoCPlaneAP?: EoCPlane;
	public EoCPlaneLT?: EoCPlane;

	public initBothViews(main: Main): void {
		main.hasAP && this.initView(main, ViewType.AP);
		main.hasLT && this.initView(main, ViewType.LT);
	}

	public initView(main: Main, viewType: ViewType): EoCPlane {
		const tools = main.getTools(viewType);

		if (!tools.EoCPlane) {
			tools.add(tools.EoCPlane = new EoCPlaneMechanical(viewType, main.caseModel.side, tools.plane!, tools.osteotomy!, tools.mechanicalAxis));
			main.measuresController.bindEoC(viewType);
			viewType === ViewType.AP ? (this.EoCPlaneAP = tools.EoCPlane) : (this.EoCPlaneLT = tools.EoCPlane);
			this.bindSync();
			this.bindHistory(main.history, viewType);
		}

		return tools.EoCPlane;
	}

	private bindSync(): void {
		if (this.EoCPlaneAP && this.EoCPlaneLT && !this.synced) {

			this.EoCPlaneAP.bindEvent("onAfterDragMove", () => {
				this.EoCPlaneLT!.verticalTranslation = this.EoCPlaneAP!.verticalTranslation!;
			});

			this.EoCPlaneLT.bindEvent("onAfterDragMove", () => {
				this.EoCPlaneAP!.verticalTranslation = this.EoCPlaneLT!.verticalTranslation!;
			});

			this.EoCPlaneAP.addEventListener("historyChanged", () => {
				this.EoCPlaneLT!.verticalTranslation = this.EoCPlaneAP!.verticalTranslation!;
			});

			this.EoCPlaneLT.addEventListener("historyChanged", () => {
				this.EoCPlaneAP!.verticalTranslation = this.EoCPlaneLT!.verticalTranslation!;
			});

			this.synced = true;
		}
	}

	private bindHistory(history: HistoryController, viewType: ViewType): void {
		const eocPlane = viewType === ViewType.AP ? this.EoCPlaneAP! : this.EoCPlaneLT!;

		eocPlane.bindEvent('onDragStart', () => {
			history.startTracking(viewType, eocPlane);
		});

		eocPlane.bindEvent('onDragEnd', () => {
			history.detectChanges(viewType);
		});
	}
}
